import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import {
  ElderQuantityInputControlComponent,
  ElderQuantityRangeValidator,
  ElderRequiredQuantityValidator,
  ElderValidationErrorDirective,
  Quantity,
  Unit,
} from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { WorkItem } from '../../../../orders/work-items/work-item'
import { Package } from '../../../../packages/package'

export interface ITerminalBatchPackageItemAssignmentDialogOptions {
  readonly pkg: Package
  readonly item: WorkItem
  readonly packagedPiecesCount: number
  readonly unPackagedPiecesCount: number
}

@Component({
  selector: 'app-terminal-batch-package-item-assignment-dialog',
  templateUrl: './terminal-batch-package-item-assignment-dialog.component.html',
  styleUrls: ['./terminal-batch-package-item-assignment-dialog.component.scss'],
  imports: [
    FormsModule,
    MatFormField,
    MatLabel,
    ElderQuantityInputControlComponent,
    ElderRequiredQuantityValidator,
    ElderQuantityRangeValidator,
    MatError,
    ElderValidationErrorDirective,
    MatButton,
    MatDialogClose,
    ElderTranslatePipe,
  ],
})
export class TerminalBatchPackageItemAssignmentDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly pkg: Package
  public readonly item: WorkItem
  public readonly packagedPiecesCount: number
  public readonly unPackagedPiecesCount: number

  public quantity: Quantity = Quantity.zero(Unit.pc)
  private dialogRef =
    inject<MatDialogRef<TerminalBatchPackageItemAssignmentDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<ITerminalBatchPackageItemAssignmentDialogOptions>(MAT_DIALOG_DATA)
    this.pkg = data.pkg
    this.item = data.item
    this.packagedPiecesCount = data.packagedPiecesCount
    this.unPackagedPiecesCount = data.unPackagedPiecesCount
    this.quantity = Quantity.from(this?.item?.orderedProduct?.toSales?.unit, 0)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }
}
